import type { ButtonHTMLAttributes, ReactNode } from 'react'
import './key.css'

export interface KeyProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-pressed'> {
  /** Primary is the one lamplight key on a screen; quiet is text only, for "Open in stagepost". Without one it is a well in the glass. */
  variant?: 'primary' | 'quiet'
  /** Set only on a key in a group of choices: true for the one chosen, false for the rest. */
  selected?: boolean
  /** Drawn left of the label, and left out of the key's name. */
  icon?: ReactNode
}

/** The game's one button: a well in the glass, or lamplight when primary, which darkens and dips a pixel when pressed. */
export function Key({ variant, selected, icon, type = 'button', className, children, ...rest }: KeyProps) {
  return (
    <button
      {...rest}
      type={type}
      className={className ? `game-key ${className}` : 'game-key'}
      data-variant={variant}
      aria-pressed={selected}
    >
      {icon && (
        <span className="game-key-icon" aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </button>
  )
}
